<template>
    <tooltip
        v-if="
            $page.props.auth.user.group_admin_permission_level === 'read-only'
        "
        width-px="300"
    >
        <template #trigger>
            <div class="opacity-25 hover:cursor-not-allowed">
                <slot />
            </div>
        </template>
        <template #content>
            Only group owners and full admins are able purchase additional
            memberships
        </template>
    </tooltip>

    <new-modal
        v-else
        size="xl"
        title="Buy memberships"
        ref="purchaseMembershipsModal"
        :close-on-bg-click="allowCancel"
        :show-close-x="allowCancel"
    >
        <template #trigger>
            <slot />
        </template>
        <template #content>
            <div class="relative h-full">
                <GroupBuyMembershipsForm
                    :existing-memberships-in-cart="existingMembershipsInCart"
                    v-on:cart-updated="updateCart"
                />
            </div>
        </template>
        <template #controls>
            <div class="flex w-full justify-end gap-4">
                <div class="btn btn-outline" v-if="allowCancel" @click="cancel">
                    Cancel
                </div>
                <div class="btn btn-primary" @click="goToPayment">
                    {{ continueButtonText }}
                </div>
            </div>
        </template>
    </new-modal>
</template>
<script>
import NewModal from "@/Components/NewModal";
import Tooltip from "@/Components/Tooltip";
import GroupBuyMembershipsForm from "@/Components/GroupBuyMembershipsForm";

export default {
    name: "GroupBuyMembershipModal",
    components: {
        GroupBuyMembershipsForm,
        NewModal,
        Tooltip,
    },
    props: {
        allowCancel: {
            type: Boolean,
            default: true,
        },
        continueButtonText: {
            type: String,
            default: "Proceed to payment",
        },
        existingMembershipsInCart: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            membershipsInCart: {},
        };
    },
    methods: {
        updateCart(cart) {
            this.membershipsInCart = cart.membershipsInCart;
        },
        goToPayment() {
            this.$inertia.get(
                route("group.cart.checkout"),
                {},
                {
                    preserveState: false,
                    replace: route().current() === "group.cart.checkout",
                }
            );
        },
        cancel() {
            this.$refs.purchaseMembershipsModal.closeModal();
        },
    },
};
</script>
